export default "__VITE_ASSET__B4xN0Iu0__"